import moment, { Moment } from "moment";
import { DropAreaPoint } from "../types/DropAreaPoint";
import { CalendarEntry } from "Components/Calendar/CalendarEntryHelper";
import { MinuteRange } from "Components/WorkingHours/types/MinuteRange";
import { getMinutesFromMoment } from "Components/WorkingHours/helpers/getMinutesFromMoment";

export function addCalendarEntriesToDayDropAreaPoints(
	day: Moment,
	points: DropAreaPoint[],
	calendarEntries: CalendarEntry[],
	visibleMinutes: MinuteRange
) {
	const visibleStart = day.clone().add(visibleMinutes.start, "minutes");
	const visibleEnd = day.clone().add(visibleMinutes.end, "minutes");

	calendarEntries.forEach((entry) => {
		const entryStart = moment.unix(entry.startTime);
		const entryEnd = moment.unix(entry.endTime);

		if (
			entryStart.isSameOrAfter(visibleStart) &&
			entryStart.isSameOrBefore(visibleEnd)
		) {
			const startMinute = getMinutesFromMoment(entryStart);
			const startPoint = points.find((point) => point.minute === startMinute);

			if (!startPoint) {
				points.push({ minute: startMinute });
			}
		}

		if (
			entryEnd.isSameOrAfter(visibleStart) &&
			entryEnd.isSameOrBefore(visibleEnd)
		) {
			const endMinute = getMinutesFromMoment(entryEnd);
			const endPoint = points.find((point) => point.minute === endMinute);

			if (endPoint) {
				endPoint.isEnd = true;
			} else {
				points.push({ minute: endMinute, isEnd: true });
			}
		}
	});
}
